<template>
  <v-dialog v-model="dialog" :width="dialogWidth" :persistent="true" transition="fade-transition">
    <v-card>
      <v-card-title class="headline">Abonniere unseren Newsletter</v-card-title>
      <v-card-text>
        <p>Verpasse keine Neuigkeiten und erfahre als erstes von spannenden Angeboten und Neuerungen</p>
        <v-btn @click="subscribe" class="primary">
          {{$t('common.subscribe')}}
        </v-btn>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="error" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { MUTATION_RAISE_NOTIFICATION } from '../plugins/store'

export default {
  name: "SubscribeNewsletterDialog",
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  data: function() {
    return {
      dialog: false
    };
  },
  watch: {
    visible: function(val) {
      this.dialog = val;
    },
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "450";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    subscribe() {
      this.$api
          .subscribeNewsletter()
          .then(() => {
            this.loading = false
            this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
              type: 'success',
              message: this.$t('newsletter.subscribed')
            })
            this.dialog = false
          })
          .catch(error => {
            this.loading = false
            this.$common.onError(error)
          })
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
</style>
